const defaultState = 0;

export default (state = defaultState, action) => {
    const { type, payload } = action;

    switch (type) {
        case "scrollHeight/set":
            return payload;
        case "scrollHeight/clear":
        case "REDUX/CLEAR":
            return defaultState;
        default:
            return state;
    }
};
